"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
export default function Ambition() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const details = [{
    label: "FOCUS",
    value: "Digital, ESG, Research, and AI"
  }, {
    label: "STATUS",
    value: "Proof of concept validated"
  }];
  return <section data-section-id="9018" id="our-story-and-ambition" className="bg-background py-24 md:py-32" ref={sectionRef}>
      <div className="mx-auto w-full max-w-[1280px] px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {}
          <div data-index={0} className={`lg:col-span-7 order-1 transition-all duration-[1100ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <div className="overflow-hidden rounded-lg">
              <div className="aspect-[4/5] md:aspect-[3/4] w-full overflow-hidden rounded-lg">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706701/img/community_impact_collaboration.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706701/img/community_impact_collaboration.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706701/img/community_impact_collaboration.webp-wvc-sizes" alt="Diverse group of students and community leaders collaborating on a digital project in a bright, modern workspace" loading="lazy" decoding="async" className={`h-full w-full object-cover transition-transform duration-[1100ms] ease-out ${isVisible ? "scale-100" : "scale-[1.04]"}`} />
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 order-2 flex flex-col justify-center">
            <div className={`transition-all duration-[720ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: "80ms"
          }}>
              
            </div>

            

            <p className={`mt-8 font-default font-normal transition-all duration-[720ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            color: "var(--ink-secondary)",
            opacity: isVisible ? 0.85 : 0,
            fontSize: "clamp(1.125rem, 1.4vw, 1.375rem)",
            lineHeight: "1.55",
            transitionDelay: "240ms"
          }}><br /><div contenteditable="false" style={{}}>Many charities have important projects that would make a real difference but lack the time, capacity or specialist expertise to deliver them. At the same time, many talented young people are looking for meaningful opportunities to build confidence, develop skills and take their first steps towards the careers they want to pursue.<br />
</div><div contenteditable="false" style={{}}>Elevate Social Outcomes exists to help bring these two challenges together. By creating structured opportunities based around real projects, organisations can strengthen their capability while young people gain valuable experience, practical skills and a clearer path towards future employment.
<br /><br /></div><div>The goal is simple: help organisations achieve more, help young people realise their potential, and create value for both in the process.
</div><div><br /></div><div data-ast-id="f:/src/pages/AboutESO/sections/Ambition.tsx|sig:4nzmbs" data-ast-start="3305" data-ast-end="3454"><br /></div><div data-ast-id="f:/src/pages/AboutESO/sections/Ambition.tsx|sig:4ncnjg" data-ast-start="3454" data-ast-end="3471"><br /></div><div data-ast-id="f:/src/pages/AboutESO/sections/Ambition.tsx|sig:4nbfsg" data-ast-start="3471" data-ast-end="3599"><br /></div></p>

            {}
            <dl className="mt-8 flex flex-col">
              {details.map((item, i) => <div key={i} data-index={i} className={`grid grid-cols-[auto_1fr] gap-x-6 md:gap-x-10 items-baseline py-5 border-b border-border/60 last:border-b-0 transition-all duration-[720ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
              transitionDelay: `${320 + i * 80}ms`
            }}>
                  
                  
                </div>)}
            </dl>

            <div className={`mt-10 transition-all duration-[720ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: "720ms"
          }}>
              
            </div>
          </div>
        </div>
      </div>
    </section>;
}